import { useEffect } from 'react';

import { useField, useForm } from 'react-final-form';

import { Alert, Typography, Box, Stack, tokens } from '@cast/design-system';
import { NotificationSeverity } from '@cast/types';

import { SeverityChip } from '../../_components';
import { KnownSeverities } from '../../constants';

import {
  RffCheckbox,
  RffFlagsGroup,
  RffFlagsGroupError,
} from '@cast/shared-rff-ui';

export const SeverityCheckboxes = () => {
  const categoryField = useField('category');
  const severitiesField = useField('selectedSeverities');
  const form = useForm();

  const isSecurityCategorySelected = categoryField.input.value === 'security';
  const allSelected =
    severitiesField.input.value?.length === KnownSeverities.length;

  useEffect(() => {
    if (isSecurityCategorySelected) {
      form.change('selectedSeverities', [NotificationSeverity.INFO]);
    }
  }, [form, isSecurityCategorySelected]);

  const handleToggleAll = () => {
    form.change('selectedSeverities', allSelected ? [] : [...KnownSeverities]);
  };

  return (
    <>
      {isSecurityCategorySelected && (
        <Alert
          color="info"
          size="sm"
          noIcon
          sx={{ mb: 16 }}
          testId="security-severity-alert"
        >
          Security reporting notifications has only one severity level which is
          &quot;Info&quot; and is selected as a default
        </Alert>
      )}
      <RffFlagsGroup name="selectedSeverities">
        {!isSecurityCategorySelected && (
          <Typography
            component="span"
            variant="P12M"
            color={tokens.theme.fg.action.primary}
            sx={{ cursor: 'pointer', userSelect: 'none' }}
            onClick={handleToggleAll}
            data-testid="alert-severity-toggle-all"
          >
            {allSelected ? 'Deselect all' : 'Select all'}
          </Typography>
        )}
        <Box
          pt="8px"
          display="grid"
          gridTemplateRows="repeat(3, auto)"
          gridAutoColumns="max-content"
          gridAutoFlow="column"
          columnGap="45px"
          rowGap="16px"
        >
          {KnownSeverities.map((severity) => (
            <Stack direction="row" gap="8px" key={severity}>
              <RffCheckbox
                name={severity}
                testId={`alert-severity-${severity}-checkbox`}
                disabled={isSecurityCategorySelected}
              />
              <SeverityChip severity={severity} size="medium" />
            </Stack>
          ))}
        </Box>
        <RffFlagsGroupError>
          {(error) => (
            <Typography
              color={tokens.theme.fg.status.error}
              variant="P12R"
              pt="4px"
            >
              {error}
            </Typography>
          )}
        </RffFlagsGroupError>
      </RffFlagsGroup>
    </>
  );
};
